export const baseUrl = '/dashboard'
export const baseLastThreeUrl = '/dashboard/invoices'
